export function initUtm() {
	const utmData = {
		structure: {
			'utm_source': 'utmSource',
			'utm_campaign': 'utmCampaign',
			'utm_medium': 'utmMedium',
			'utm_id': 'utmId',
		},
		structureR: {},
		data: {}
	}
	// update utmData
	for ( const [key, value] of Object.entries(utmData.structure) ) {
		utmData.structureR[value] = key;
		utmData.data[value] = false;
	}

	// Get utm query params
	let hasQueryStringValues = false;
	let queryString = window.location.search;

	if ( queryString ) {
		// let urlParams = new URLSearchParams(queryString);
		for (const [key, value] of new URLSearchParams(queryString).entries()) {
	        if ( utmData.structure.hasOwnProperty(key) ) {
	        	let dataKey = utmData.structure[key];
	        	utmData.data[dataKey] = value;
	        	hasQueryStringValues = true;
	        }
	    }
	}

	// If query params, set cookies
	// unset empty values
	if ( hasQueryStringValues ) {
		for ( const [key, value] of Object.entries(utmData.data) ) {
			let cookieName = `_act_${key}`;
			if ( value !== false ) {
				// set cookie
				let cookieValue = encodeURIComponent(value);
				localStorage.setItem(cookieName, cookieValue);
			} else {
				// unset cookie
				localStorage.removeItem(cookieName);
			}
		}
	}

	// Check cookies
	let storageValues = {};
	for ( const [key, value] of Object.entries(utmData.structure) ) {
		let cookieName = `_act_${value}`;
		let cookie = localStorage.getItem(cookieName);
		if ( cookie !== null ) {
			storageValues[value] = cookie;
			utmData.data[value] = cookie;
		}
	}

	// update Gravity forms
	for ( const [key, value] of Object.entries(utmData.data) ) {
		let gfQuery = "input[value='{"+key+"}']";
		let gfInputList = document.querySelectorAll(gfQuery);
		if ( gfInputList.length === 0 ) continue;
		for (let i = 0; i < gfInputList.length; i++) {
			if ( value !== false ) {
				gfInputList[i].value = value;
			} else {
				gfInputList[i].value = '';
			}
		}
	}

	if ( Object.keys(storageValues).length === 0 ) { return; }
	
	// if utm, update Cvent links
	let cventLinks = document.querySelectorAll(`a[href*="//cvent.me"]`);
	
	if ( cventLinks.length !== 0 ) {
		for (let i = 0; i < cventLinks.length; i++) {
			let url = new URL(cventLinks[i].href);
			let params = url.searchParams;
			for ( const [key, value] of Object.entries(utmData.data) ) {
				if ( value !== false ) {
					params.set(utmData.structureR[key], value);
				}
			}
			url.search = params.toString();
			cventLinks[i].href = url.toString();
		}
	}

}